module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_detail_mens_make-4c70e6efb66f233a9f99bfa5618c22bd.jpg";